import {ChangeDetectionStrategy, Component, ContentChild, Input, TemplateRef} from "@angular/core";

@Component({
	selector:'cp-separated-list',
	templateUrl: './separated.list.template.html',
	styleUrls: ['./separated.list.style.scss'],
	changeDetection:ChangeDetectionStrategy.OnPush
})
export class SeparatedListComponent {
	@Input() list: any[];
	@Input() addSpaces: boolean;
	@Input() addTitle: boolean;

	@ContentChild(TemplateRef,{static:false}) tpl;

	public title(separator: string): string {
		return this.addTitle ? this.list.join(separator) : '';
	}
}
